import { TEAM_MEMBER_ROLE_LABELS, memberTeamsSchema, type MemberTeams } from '@growup/site-shared';
import { Card, StatusBadge } from '@growup/ui';
import { useEffect, useState } from 'react';

import { getJson } from '../api';

const day = (d: string) => d.split('-').reverse().join('/');

/**
 * As equipas na ficha do socio (docs/equipas, parte 4b, RF-EQ5). Sem equipas,
 * ou sem acesso, o cartao nao aparece.
 */
export function MemberTeamsCard({ accountId }: { accountId: string }) {
  const [teams, setTeams] = useState<MemberTeams | null>(null);

  useEffect(() => {
    setTeams(null);
    getJson(`/api/site/teams/members/${accountId}`, memberTeamsSchema)
      .then(setTeams)
      .catch(() => undefined);
  }, [accountId]);

  if (teams === null || (teams.current.length === 0 && teams.past.length === 0)) return null;

  return (
    <Card headingLevel={2} title="Equipas">
      <div className="flex flex-col gap-3">
        <ul className="flex flex-col gap-2">
          {teams.current.map((t) => (
            <li key={`${t.slug}-${t.joinedOn}`} className="flex flex-wrap items-center gap-2">
              <span className="font-semibold">{t.name}</span>
              <span className="text-caption text-gu-ink-muted">
                {[
                  t.game,
                  TEAM_MEMBER_ROLE_LABELS[t.role],
                  t.gameRole,
                  t.jerseyNumber !== null ? `nº ${String(t.jerseyNumber)}` : null,
                  t.season ? `época ${t.season}` : `desde ${day(t.joinedOn)}`,
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </span>
              {t.pending ? <StatusBadge tone="warning">Autorização pendente</StatusBadge> : null}
              {t.rules === 'pending' ? (
                <StatusBadge tone="warning">Regulamento por aceitar</StatusBadge>
              ) : null}
            </li>
          ))}
        </ul>
        {teams.past.length > 0 ? (
          <ul className="flex flex-col gap-1 text-caption text-gu-ink-muted">
            {teams.past.map((t) => (
              <li key={`${t.slug}-${t.joinedOn}`}>
                {t.name} · {TEAM_MEMBER_ROLE_LABELS[t.role]}
                {t.season ? ` · época ${t.season}` : ''} · {day(t.joinedOn)}
                {t.leftOn ? ` a ${day(t.leftOn)}` : ''}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </Card>
  );
}
